

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams, useNavigate, useLocation } from 'react-router-dom';
import EjecutaTratamientoModal from './screens/EjecutaTratamientoModal';
import TratamientoScreen from './screens/TratamientoScreen';
import NotasModal from './screens/NotasModal';
import InfoScreen from './screens/InfoScreen';
import LandingPage from './screens/LandingPage';
import ContactoScreen from './screens/ContactoScreen';
import LoginScreen from './screens/LoginScreen';
import PacienteDashboard from './screens/PacienteDashboard';
import ComoFuncionaScreen from './screens/ComoFuncionaScreen';
import FAQScreen from './screens/FAQScreen';
import ContactaScreen from './screens/ContactaScreen';
import RelajacionScreen from './screens/RelajacionScreen';
import SonoTerapiaScreen from './screens/SonoTerapiaScreen';
import { infoData } from './data/infoData';

function TratamientoRouteWrapper({ token, userId, navigate }) {
  const { id } = useParams();
  const [showNotas, setShowNotas] = React.useState(false);
  const [showIntro, setShowIntro] = React.useState(true);
  if (!token || !userId) return <Navigate to="/login" replace />;
  const handleNotas = () => setShowNotas(true);
  const handleRelax = () => navigate('/relajacion');
  return (
    <>
      {showIntro && (
        <EjecutaTratamientoModal
          onClose={() => navigate('/dashboard')}
          onStart={() => setShowIntro(false)}
          tratamientoId={id}
        />
      )}
      {!showIntro && (
        <TratamientoScreen
          tratamientoId={id}
          token={token}
          userId={userId}
          onNotas={handleNotas}
          onRelax={handleRelax}
          onFinish={() => navigate('/dashboard')}
        />
      )}
      {showNotas && (
        <NotasModal
          initialNota={''}
          initialPrivacidad={true}
          onSave={() => setShowNotas(false)}
          onClose={() => setShowNotas(false)}
          loading={false}
        />
      )}
    </>
  );
}

function InfoScreenWrapper() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tratamientoId = searchParams.get('id');
  let tratamientos = [];
  try {
    tratamientos = JSON.parse(localStorage.getItem('tratamientos')) || [];
  } catch (e) { tratamientos = []; }
  const tratamiento = tratamientos.find(t => String(t.id) === String(tratamientoId));
  const logotema = tratamiento && tratamiento.carpeta ? `/Tratamientos/${tratamiento.carpeta}/logotema.png` : infoData.logotema;
  const carpeta = tratamiento && tratamiento.carpeta ? tratamiento.carpeta : null;
  const [texto, setTexto] = useState('');
  const [loading, setLoading] = useState(true);
  React.useEffect(() => {
    if (!carpeta) return;
    fetch(`/Tratamientos/${carpeta}/info.txt`)
      .then(res => res.ok ? res.text() : '')
      .then(txt => setTexto(txt))
      .finally(() => setLoading(false));
  }, [carpeta]);
  // Separar texto en dos partes si contiene ---IMAGEN---
  let textoArr = texto.includes('---IMAGEN---') ? texto.split('---IMAGEN---') : [texto];
  const imagen_info = carpeta ? `/Tratamientos/${carpeta}/info.jpg` : infoData.imagen_info;
  return (
    <InfoScreen
      logotema={logotema}
      texto={textoArr}
      imagen_info={imagen_info}
      onBack={() => navigate(-1)}
    />
  );
}

function App() {
  const navigate = useNavigate();
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [userId, setUserId] = useState(localStorage.getItem('userId') || '');
  const [userUid, setUserUid] = useState(localStorage.getItem('uid') || '');
  const [role, setRole] = useState(localStorage.getItem('role') || '');
  const [tratamientos, setTratamientos] = useState([]);
  const [loading, setLoading] = useState(false);

  // Handler de login
  const handleLogin = (tk, uid, rl, userUid) => {
    setToken(tk);
    setUserId(uid);
    setUserUid(userUid);
    setRole(rl);
    localStorage.setItem('token', tk);
    localStorage.setItem('userId', uid);
    localStorage.setItem('uid', userUid);
    localStorage.setItem('role', rl);
    navigate('/dashboard', { replace: true });
  }

  // Handler de logout
  const handleLogout = () => {
    setToken('');
    setUserId('');
    setRole('');
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('role');
    navigate('/login', { replace: true });
  };

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
  <Route path="/login" element={<LoginScreen onLogin={handleLogin} loading={loading} />} />
  <Route path="/contacto" element={<ContactoScreen />} />
      <Route path="/dashboard" element={token && userId ? <PacienteDashboard token={token} userId={userId} setTratamientos={setTratamientos} /> : <Navigate to="/login" replace />} />
      <Route path="/info" element={<InfoScreenWrapper />} />
  <Route path="/como-funciona" element={<ComoFuncionaScreen onBack={() => navigate(-1)} />} />
  <Route path="/faq" element={<FAQScreen onBack={() => navigate(-1)} />} />
  <Route path="/contacta" element={<ContactaScreen userUid={userUid} token={token} onBack={() => navigate(-1)} />} />
  <Route path="/relajacion" element={<RelajacionScreen onBack={() => navigate('/dashboard')} />} />
  <Route path="/sonoterapia" element={token && userId ? <SonoTerapiaScreen onBack={() => navigate('/dashboard')} /> : <Navigate to="/login" replace />} />
      <Route path="/tratamiento/:id" element={<TratamientoRouteWrapper token={token} userId={userId} navigate={navigate} />} />
      {/* Agrega más rutas según lo necesites */}
    </Routes>
  );
}


function AppWithRouter() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWithRouter;
